import React from 'react';
import { Link } from 'react-router-dom';
import './TextBlock.css';

function TextBlock({ heading1, heading2, content, link, linkText, quote }) {
    return (
        <section className="text_block spacing">
            <div className="text_block_inner container">
                <div className="col-1">
                    {heading1 && <h3>{heading1}</h3>}
                    {heading2 && <h3 className="cambon_font">{heading2}</h3>}
                    {content && <p>{content}</p>}
                    {link && <Link className='animateLine' to={`/${link}`}>{linkText}</Link> }
                    {quote && <p><small>{quote}</small></p>}
                    

                </div>
            </div>
        </section >
    )
}

export default TextBlock